<template>
  <v-layout row wrap>
    <v-flex xs12 sm6>
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="selectedtimestart"
        persistent
        
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="selectedtimestart"
            label="Start Date"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="selectedtimestart" type="date" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn color="primary" @click="$refs.dialog.save(selectedtimestart);emit()">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex xs12 sm6>
      <v-dialog
        ref="dialog2"
        v-model="modal2"
        :return-value.sync="selectedtimeend"
        persistent
        
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="selectedtimeend"
            label="End Date"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="selectedtimeend" type="date" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal2 = false">Cancel</v-btn>
          <v-btn color="primary" @click="$refs.dialog2.save(selectedtimeend);emit()">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>

import moment from 'moment';

moment.fn.fromNowOrNow = function (a) {
  if (Math.abs(moment().diff(this)) < 25000) { // 25 seconds before or after now
    return 'just now';
  }
  return this.fromNow(a);
};

export default {
  data: () => ({
       selectedtimestart : moment().subtract(7,'days').format("YYYY-MM-DD"),
       selectedtimeend : moment().format("YYYY-MM-DD"),
       modal : false,
       modal2: false
  }),
  computed: {
  },
  created(){
      this.emit()
  },
  methods: {


      emit(){

          var startDate = moment.utc(this.selectedtimestart,"YYYY-MM-DD")
          var endDate = moment.utc(this.selectedtimeend,"YYYY-MM-DD")
          
          this.$emit('updateDate',startDate,endDate)
      }

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
